/* eslint-disable prettier/prettier */

/* eslint-disable no-console */
import axios from 'axios';
import { auth } from '../api/ApiUrl';
import { decodeToken, capturarDatosIsam } from '../UtilsLogin/UtilsLogin';
import { storeArq } from 'correos-arq-utils';

var catchAuth = function catchAuth(status, rolesWeb) {
  return new Promise(function (resolve, reject) {
    // Cargar los datos del storeArq
    storeArq.load(); // TODO: puede ser necesario alterar esta función - es la que te manda al login cuando el token expira

    if (status === '401' || status === 401) {
      // console.log('Hola desde CatchAuth');
      if (storeArq.data.tipo_integracion === 'INTERN') {
        axios.post(auth.refreshTokenISAM, "grant_type=refresh_token" + "&refresh_token=" + storeArq.data.auth.refresh_token // @ts-ignore
        + '&client_secret=' + window._env_.REACT_APP_CLIENT_SECRET_ISAM // @ts-ignore
        + "&client_id=" + window._env_.REACT_APP_CLIENT_ID_ISAM + "&scope=openid", {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          capturarDatosIsam(response.data); // decodificar el token - sacar la info (paso como parametro la respuesta [infoEncoded])

          decodeToken(storeArq.data.auth.token, rolesWeb);
          resolve(storeArq.data.auth.token);
        })["catch"](function (error) {
          console.log('error.catchAuth.ISAM ', error);
          reject(error);
        });
      } else {
        axios.post( // @ts-ignore
        auth.refreshTokenC_ID + '/' + window._env_.REACT_APP_CLIENT_ID_C_ID, {
          JWT: storeArq.data.auth.token
        }).then(function (res) {
          if (res.data.Validated === 'true') {
            storeArq.data.auth.token = res.data.Token;
            storeArq.save();
            decodeToken(res.data.Token, rolesWeb);
            resolve(storeArq.data.auth.token);
          } else {
            sessionStorage.removeItem('storeArq.data');
          }
        })["catch"](function (error) {
          console.log('error.catchAuth.C_ID: ', error);
          reject(error);
        });
      }
    }
  });
};

var expireAuth = function expireAuth(rolesWeb) {
  return new Promise(function (resolve, reject) {
    // Cargar los datos del storeArq
    storeArq.load(); // TODO: puede ser necesario alterar esta función - es la que te manda al login cuando el token expira
    // console.log('Hola desde expireAuth');

    if (storeArq.data.tipo_integracion === 'INTERN') {
      axios.post(auth.refreshTokenISAM, "grant_type=refresh_token" + "&refresh_token=" + storeArq.data.auth.refresh_token // @ts-ignore
      + '&client_secret=' + window._env_.REACT_APP_CLIENT_SECRET_ISAM // @ts-ignore
      + "&client_id=" + window._env_.REACT_APP_CLIENT_ID_ISAM + "&scope=openid", {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        capturarDatosIsam(response.data); // decodificar el token - sacar la info (paso como parametro la respuesta [infoEncoded])

        decodeToken(storeArq.data.auth.token, rolesWeb);
        resolve(storeArq.data.auth.token);
      })["catch"](function (error) {
        console.log('error.expireAuth.ISAM ', error);
        reject(error);
      });
    } else {
      axios.post( // @ts-ignore
      auth.refreshTokenC_ID + '/' + window._env_.REACT_APP_CLIENT_ID_C_ID, {
        JWT: storeArq.data.auth.token
      }).then(function (res) {
        if (res.data.Validated === 'true') {
          storeArq.data.auth.token = res.data.Token;
          storeArq.save();
          decodeToken(res.data.Token, rolesWeb);
          resolve(storeArq.data.auth.token);
        } else {
          sessionStorage.removeItem('storeArq.data');
        }
      })["catch"](function (error) {
        console.log('error.expireAuth.C_ID: ', error);
        reject(error);
      });
    }
  });
};

export var CatchPerm = {
  catchAuth: catchAuth,
  expireAuth: expireAuth
};